export default __webpack_public_path__ + "static/media/gld.91819f42.jpg";